/* Collage lightbox: click a collage image to zoom, arrows/keys to navigate */
(function () {
  var lightbox = null;
  var images = [];
  var index = 0;

  function build() {
    lightbox = document.createElement('div');
    lightbox.className = 'collage-lightbox';
    lightbox.innerHTML =
      '<img class="collage-lightbox__img" alt="">' +
      '<button type="button" class="collage-lightbox__close" aria-label="Close">' +
      '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button type="button" class="collage-lightbox__arrow collage-lightbox__arrow--prev" aria-label="Previous">' +
      '<svg viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 1.5L2 8l6.5 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button type="button" class="collage-lightbox__arrow collage-lightbox__arrow--next" aria-label="Next">' +
      '<svg viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1.5L8 8l-6.5 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<div class="collage-lightbox__counter"></div>';

    lightbox.querySelector('.collage-lightbox__close').addEventListener('click', close);
    lightbox.querySelector('.collage-lightbox__arrow--prev').addEventListener('click', function (e) {
      e.stopPropagation();
      show(index - 1);
    });
    lightbox.querySelector('.collage-lightbox__arrow--next').addEventListener('click', function (e) {
      e.stopPropagation();
      show(index + 1);
    });
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target.classList.contains('collage-lightbox__img')) {
        close();
      }
    });

    document.body.appendChild(lightbox);
  }

  function show(i) {
    index = (i + images.length) % images.length;
    var img = lightbox.querySelector('.collage-lightbox__img');
    img.src = images[index];
    lightbox.querySelector('.collage-lightbox__counter').textContent = (index + 1) + ' / ' + images.length;

    // Preload neighbours
    [index + 1, index - 1].forEach(function (n) {
      var pre = new Image();
      pre.src = images[(n + images.length) % images.length];
    });
  }

  function open(list, startIndex) {
    images = list;
    if (!lightbox) {
      build();
    }
    show(startIndex);
    lightbox.classList.add('is-open');
    lightbox.style.display = 'flex';
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
  }

  function close() {
    lightbox.classList.remove('is-open');
    lightbox.style.display = 'none';
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
  }

  function onKey(event) {
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowRight') show(index + 1);
    if (event.key === 'ArrowLeft') show(index - 1);
  }

  document.addEventListener('click', function (event) {
    var img = event.target.closest('.product__media-collage[data-collage-zoom] .product__media-collage-item:not(.is-filtered) img');
    if (!img) {
      return;
    }

    var collage = img.closest('.product__media-collage');
    var items = Array.prototype.slice.call(
      collage.querySelectorAll('.product__media-collage-item:not(.is-filtered) img')
    );
    var list = items.map(function (el) {
      return el.getAttribute('data-full') || el.currentSrc || el.src;
    });

    open(list, items.indexOf(img));
  });
})();

/* Relocate "Buy with" into the buy box column (desktop, collage modes)
   and drive the AllSaints-style sticky offset: if the column is taller than
   the viewport it pins by its bottom edge, otherwise by its top. */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 1000px)');

  function getInfo() {
    return document.querySelector('.product--gallery-collage .product__info, .product--gallery-collage-hero .product__info');
  }

  function relocateBuyWith() {
    if (!DESKTOP.matches) {
      return;
    }

    var info = getInfo();
    var featured = document.querySelector('.product-content__featured-products');

    if (!info || !featured || info.contains(featured)) {
      return;
    }

    var section = featured.closest('.shopify-section') || featured.closest('section');
    info.appendChild(featured);

    if (section) {
      var content = section.querySelector('.product-content');
      if (content && content.children.length === 0) {
        section.style.display = 'none';
      }
    }
  }

  function baseOffset() {
    var cs = getComputedStyle(document.documentElement);
    var num = function (name) {
      return parseFloat(cs.getPropertyValue(name)) || 0;
    };
    return 24 + num('--header-height') * num('--enable-sticky-header') + num('--announcement-bar-height') * num('--enable-sticky-announcement-bar');
  }

  function updateStickyOffset() {
    var info = getInfo();

    if (!info) {
      return;
    }

    if (!DESKTOP.matches) {
      info.style.top = '';
      return;
    }

    var base = baseOffset();
    var overflow = info.offsetHeight + base + 24 - window.innerHeight;
    info.style.top = overflow > 0 ? -(overflow - base) + 'px' : base + 'px';
  }

  function init() {
    relocateBuyWith();
    updateStickyOffset();

    var info = getInfo();
    if (info && 'ResizeObserver' in window) {
      new ResizeObserver(updateStickyOffset).observe(info);
    }

    window.addEventListener('resize', updateStickyOffset);

    // Accordion toggles change the column height
    document.addEventListener('toggle', function (event) {
      if (event.target.classList && event.target.classList.contains('product-accordion')) {
        updateStickyOffset();
      }
    }, true);
  }

  init();
})();